import React from 'react';
import Header from '../Header';
import Footer from '../Footer';
import Form from '../Form';

import { affiliatesContainerClass } from './styles.ve.css';

interface SectionContextInterface {
  section: string | null;
}

export const SectionContext = React.createContext<SectionContextInterface>({ section: null });

const App = () => (
  <div className={affiliatesContainerClass}>
    <SectionContext.Provider value={{ section: 'header' }}>
      <Header />
    </SectionContext.Provider>
    <Form />
    <SectionContext.Provider value={{ section: 'footer' }}>
      <Footer />
    </SectionContext.Provider>
  </div>
);

export default App;
